/**
 * Run work after the first real input, or after a long idle fallback.
 * Keeps analytics and the homepage app bundle off the LCP / unused-JS path.
 */
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll', 'mouseover'] as const;

export function deferUntilNeeded(task: () => void, fallbackMs = 10000): () => void {
  let done = false;
  let timeoutId = 0;

  const run = () => {
    if (done) return;
    done = true;
    INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, run));
    window.removeEventListener('load', startFallback);
    if (timeoutId) window.clearTimeout(timeoutId);
    task();
  };

  const startFallback = () => {
    if (done) return;
    timeoutId = window.setTimeout(run, fallbackMs);
  };

  INTERACTION_EVENTS.forEach((event) => {
    window.addEventListener(event, run, { once: true, passive: true });
  });

  if (document.readyState === 'complete') {
    startFallback();
  } else {
    window.addEventListener('load', startFallback, { once: true });
  }

  return () => {
    if (done) return;
    done = true;
    INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, run));
    window.removeEventListener('load', startFallback);
    if (timeoutId) window.clearTimeout(timeoutId);
  };
}
